import { type AvailabilityInfo } from "~/domains/product/api/pna/AvailabilityInfo";
import { selectPackageInStockAmount } from "./packagingInformationEntrySelectors";

import { isNonNull } from "~/common/utils/reducers";

export const selectTotalInStockAmount = (availabilityInfo?: AvailabilityInfo | null) => {
  return availabilityInfo?.packagingInformation.map(selectPackageInStockAmount).reduce((a, b) => a + b, 0) ?? 0;
};

export const selectProductIsInStock = (availabilityInfo?: AvailabilityInfo | null) => {
  return selectTotalInStockAmount(availabilityInfo) > 0;
};

export const selectEarliestReplenishmentLeadTimeDate = (availabilityInfo?: AvailabilityInfo | null): Date | null => {
  return (
    availabilityInfo?.packagingInformation
      .map((pack) => pack.replenishmentLeadTimeDate)
      .filter(isNonNull)
      .sort(sortDateAsc)[0] ?? null
  );
};

function sortDateAsc(a: Date, b: Date) {
  // @ts-ignore
  return a - b;
}
